(function() {

    'use strict';

    angular
        .module('app.filter')
        .filter('newline', newline);

    function newline() {
        return html => html.replace(/\n/g, '<br/>');
    }
})();
